import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { CheckboxModel } from '../../../../core/models/checkbox.model';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: CheckboxModel;

  fieldName: any;
  fieldErrors: any;
  fieldHasErrorB = false;
  fieldTouch = false;
  fieldRequired = false;
  /**
   * @ignore
   */
  constructor() { }
  /**
   * @ignore
   */
  ngOnInit(): void {
    if (!this.checkDataCompOk()) { return; }
    this.fieldName = this.DATA_CONFIG.linkFormPath;
    this.fieldRequired = false;
    if (this.DATA_CONFIG.error !== '') { this.fieldRequired = true; }
    this.getError(this.fieldName);
    this.setDefaultValueForm();
  }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }

  /**
   * @description Para guardar el valor por defecto del formulario desde la configuracion
   */
  private setDefaultValueForm(): void {
    if (this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value === null && this.DATA_CONFIG &&
      (this.DATA_CONFIG.checked === true ||
        this.DATA_CONFIG.checked === false)
    ) {
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath)
        .setValue(this.DATA_CONFIG.checked);
    }
  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  public updateData(): void {
    if (!this.checkDataCompOk()) { return; }
    const CURRENT_VALUE_BOOLEAN = !!this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(!CURRENT_VALUE_BOOLEAN);
    if (CURRENT_VALUE_BOOLEAN === false && this.fieldRequired) {
      this.fieldHasErrorB = false;
    }
    if (CURRENT_VALUE_BOOLEAN !== false && this.fieldRequired) {
      this.fieldHasErrorB = true;
    }
  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  public getValue(): boolean {
    let valueB = false;
    if (this.checkDataCompOk()) {
      valueB = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    }
    return valueB;
  }

  /**
   *
   * @param field field to mark focus
   */
  onFocusInput(controlName: any): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.fieldTouch = true;
    const VALUE_EL: any = this.FORM_DATA.get(controlName).value;
    if (VALUE_EL === true && this.fieldRequired) {
      this.fieldHasErrorB = false;
    }
    if (VALUE_EL !== true && this.fieldRequired) {
      this.fieldHasErrorB = true;
    }
  }

  /**
   *
   * @param field field to check erros
   */
  getError(controlName: string): string {
    let errorMsg = '';
    this.fieldErrors = '';
    // this.fieldRequired = this.DATA_CONFIG.error !== '' ? true : false;
    const CONTROL: AbstractControl = this.FORM_DATA.get(controlName);

    if (this.fieldRequired && CONTROL.value === false) {
      this.FORM_DATA.get(controlName).setErrors({ required: true });
    } else {
      this.FORM_DATA.get(controlName).setErrors(null);
    }

    if (CONTROL.invalid && CONTROL.errors !== null) {
      errorMsg = JSON.stringify(CONTROL.errors);
      this.fieldErrors = CONTROL.errors;
    }
    return errorMsg;
  }

}
